import Vue from 'vue'
import store from '@/store'

export const permission = {
  bind(el, binding, vnode) {
    const action = binding.value
    const permissions = store.getters.permission
    if(el && action) {
      if(permissions.includes(action)){
        return true
      }else{
        if (el.parentNode){
          el.parentNode.removeChild(el)
        }
      }
    }
  }
} 

Vue.directive('permission', permission)




// WEBPACK FOOTER //
// ./src/directives/permission.js